import React from 'react';
import'./NotFound.css'
const NotFound = () => {
    return (
        <div className="notFound">
            <h1>404</h1>
            <h3>page not found</h3>
        </div>
    );
};

export default NotFound;